import React, { Component } from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import { connect } from "react-redux";
import settings from "../../settings";
import PersonDetail from "./Platinum/PersonDetail";
import PlatinumAddressHistory from "./Platinum/PlatinumAddressHistory";
import UCCFiling from "./Platinum/UCCFiling";
import Associates from "./Platinum/Associates";
import LiensJudgements from "./Platinum/LiensJudgements";
import DriverLiencesDetails from "./Platinum/DriverLiencesDetails";
import VoterRegistrations from "./Platinum/VoterRegistrations";
import NeighborsCurrent from "./Platinum/NeighborsCurrent";
import Relatives from "./Platinum/Relatives";
import ConcealedWeaponsPermits from "./Platinum/ConcealedWeaponsPermits";
import ProfessionalLicenses from "./Platinum/ProfessionalLicenses";
import EmailReportSection from "./EmailReportSection";
import CriminalRecordsPrimarySource from "./Platinum/CriminalRecordsPrimarySource";
import {
  stickyNavInitialize,
  stickyNavInitializeContext,
} from "../../actions/stickyNavAction";
import ShowAllElements from "./Silver/ShowAllElements";
import MotorVehiclesSilverReport from "./Silver/MotorVehiclesSilverReport";
import HuntingPermits from "./Silver/HuntingPermits";

class PersonSilverReport extends Component {
  constructor(props) {
    super(props);
    this.reportRefs = [];
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentIndex !== undefined) {
      this.onReportIndexChanged(nextProps.currentIndex);
    }
    if (nextProps.additionalData !== null) {
      this.loadData(nextProps);
    }
  }

  onReportIndexChanged = (currentIndex) => {
    const reportRef = this.reportRefs[
      currentIndex < this.reportRefs.length ? currentIndex : 0
    ];
    const section = ReactDOM.findDOMNode(reportRef.current);
    if (section !== undefined && section !== null) {
      section.scrollIntoView();
    } else if (this.state.navs && this.state.navs.length > currentIndex) {
      const nav = this.state.navs[currentIndex];
      const element = document.getElementById(`nav_${nav.name}`);
      if (element) element.scrollIntoView();
    }
  };

  loadData = (props) => {
    if (this.state.navs) return;

    const navs = [];
    this.reportRefs = [];
    let reportTypes = settings.compSilverDefaultReportTypes;
    if (
      props.additionalData !== undefined &&
      props.additionalData.optReportType === "compplus"
    ) {
      reportTypes = settings.compPlusDefaultReportTypes;
    }
    const navRefMap = {};
    const defRef = React.createRef();
    navRefMap[settings.defaultSection.sectionName] = {
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      ref: defRef,
    };
    navs.push({
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      count: undefined,
    });
    this.reportRefs.push(defRef);

    _.forEach(settings.sectionReports, (rep) => {
      if (_.findIndex(reportTypes, (a) => a === rep.sectionName) !== -1) {
        const ref = React.createRef();
        navRefMap[rep.sectionName] = {
          name: rep.sectionName,
          display: rep.displayName,
          ref,
        };
        navs.push({
          name: rep.sectionName,
          display: rep.displayName,
          count: undefined,
        });
        this.reportRefs.push(ref);
      }
    });

    const { internalID, savedResultID } = props.additionalData;
    this.setState({
      reportTypes,
      navRefMap,
      internalID,
      savedResultID,
      navs,
    });
    const stickyNav = props.stickyNav;
    stickyNav.navs = navs;
    props.stickyNavInitialize(stickyNav);
    this.onReportIndexChanged(1);
  };

  updateItemCountBySection = (sectionName, count) => {
    const stickyNav = this.props.stickyNav;
    const navs = stickyNav.navs;
    const currentSection = _.find(navs, (n) => n.name === sectionName);
    if (currentSection !== undefined) {
      currentSection.count = count;
    }
    stickyNav.navs = navs;

    this.props.stickyNavInitializeContext(stickyNav);
  };

  render() {
    const { reportData } = this.props;
    // const personResult = _.get(reportData, "personReport.person[0]");
    let navRefMapLength = 0;
    if (this.state !== null && this.state.navRefMap !== undefined) {
      navRefMapLength = Object.keys(this.state.navRefMap).length;
    }
    const reportRoot = _.get(
      reportData,
      "personReport.response[0].output[0].extendedReports[0].extendedReport[0]"
    );
    return (
      <div ref={this.props.stickyNav.handleContextRef} id={`report`}>
        {this.state && this.state.navRefMap && (
          <div>
            <PersonDetail
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap[settings.defaultSection.sectionName]
                      .ref
                  : undefined
              }
              {...this.props}
              reportData={reportData}
            />
            <PlatinumAddressHistory
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.addresshistory.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.addresshistory.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Associates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.associates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.associates.name}
              sectionTitle={this.state.navRefMap.associates.display}
              node={_.get(reportRoot, "associates[0].associate")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.bank.ref : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.bank.name}
              sectionTitle={this.state.navRefMap.bank.display}
              node={_.get(
                reportRoot,
                "personalBankruptcyFilings[0].personalBankruptcyFiling"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.businessAssociations.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.businessAssociations.name}
              sectionTitle={this.state.navRefMap.businessAssociations.display}
              node={_.get(reportRoot, "businessAssociations[0].business")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.corporateFilings.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.corporateFilings.name}
              sectionTitle={this.state.navRefMap.corporateFilings.display}
              node={_.get(reportRoot, "corporateFilings[0].corporation")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CriminalRecordsPrimarySource
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.criminal.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.criminal.name}
              node={_.get(reportRoot, "criminalRecords[0].criminal")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <DriverLiencesDetails
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.driverLicense.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.driverLicense.name}
              node={[reportRoot]}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <EmailReportSection
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.email.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.email.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.employers.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.employers.name}
              sectionTitle={this.state.navRefMap.employers.display}
              node={_.get(reportRoot, "employers[0].employer")}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.evictions.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.evictions.name}
              sectionTitle={this.state.navRefMap.evictions.display}
              node={_.get(reportRoot, "evictions[0].eviction")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.aircraft.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.aircraft.name}
              sectionTitle={this.state.navRefMap.aircraft.display}
              node={_.get(reportRoot, "aircrafts[0].aircraft")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <HuntingPermits
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.huntingPermits.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.huntingPermits.name}
              node={_.get(reportRoot, "huntingPermits[0].huntingPermit")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <LiensJudgements
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.liens.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.liens.name}
              node={_.flatten(
                _.concat(
                  _.get(
                    reportRoot,
                    "personalLienFilings[0].personalLienFiling"
                  ),
                  _.get(
                    reportRoot,
                    "personalJudgmentFilings[0].personalJudgmentFiling"
                  )
                )
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <NeighborsCurrent
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.neighbors.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.neighbors.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.pilotLicenses.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.pilotLicenses.name}
              sectionTitle={this.state.navRefMap.pilotLicenses.display}
              node={_.get(reportRoot, "pilotLicenses[0].pilotLicense")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Associates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.possibleAssociates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.possibleAssociates.name}
              sectionTitle={this.state.navRefMap.possibleAssociates.display}
              node={_.get(
                reportRoot,
                "possibleAssociates[0].possibleAssociate"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.professionalAssociations.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.professionalAssociations.name}
              sectionTitle={
                this.state.navRefMap.professionalAssociations.display
              }
              node={_.get(
                reportRoot,
                "professionalAssociations[0].professionalAssociation"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ProfessionalLicenses
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.professionallicenses.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.professionallicenses.name}
              node={_.get(
                reportRoot,
                "professionalLicenses[0].professionalLicense"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.properties.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.properties.name}
              sectionTitle={this.state.navRefMap.properties.display}
              node={_.get(reportRoot, "currentProperties[0].property")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.pastProperties.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.pastProperties.name}
              sectionTitle={this.state.navRefMap.pastProperties.display}
              node={_.get(reportRoot, "pastProperties[0].property")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.propertyForeclosures.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.propertyForeclosures.name}
              sectionTitle={this.state.navRefMap.propertyForeclosures.display}
              node={_.get(
                reportRoot,
                "propertyForeclosures[0].propertyForeclosure"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.propertyTaxes.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.propertyTaxes.name}
              sectionTitle={this.state.navRefMap.propertyTaxes.display}
              node={_.get(reportRoot, "propertyTaxes[0].propertyTax")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Relatives
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.relatives.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.relatives.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.tradeMarks.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.tradeMarks.name}
              sectionTitle={this.state.navRefMap.tradeMarks.display}
              node={_.get(reportRoot, "tradeMarks[0].tradeMark")}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <UCCFiling
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.ucc.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.ucc.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <MotorVehiclesSilverReport
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.vehicles.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.vehicles.name}
              sectionTitle={this.state.navRefMap.vehicles.display}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <VoterRegistrations
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.voterregistrations.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.voterregistrations.name}
              node={_.get(
                reportRoot,
                "voterRegistrations[0].voterRegistration"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.watchListRecords.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.watchListRecords.name}
              sectionTitle={this.state.navRefMap.watchListRecords.display}
              node={_.get(reportRoot, "watchListRecords[0].watchListRecord")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ConcealedWeaponsPermits
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.weapon.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.weapon.name}
              node={_.get(
                reportRoot,
                "concealedWeaponPermits[0].concealedWeaponPermit"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.wikipediaLinks.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.wikipediaLinks.name}
              sectionTitle={this.state.navRefMap.wikipediaLinks.display}
              node={_.get(reportRoot, "wikipediaLinks[0].wikipediaLink")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <br />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentIndex: state.nav.currentIndex,
    stickyNav: state.stickyNav,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  stickyNavInitialize,
  stickyNavInitializeContext,
})(PersonSilverReport);



// WEBPACK FOOTER //
// ./src/components/reports/PersonSilverReport.js